import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute() {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading)
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <div className="font-mono-tech text-xs uppercase tracking-[0.3em] text-slate-400 animate-pulse">
          Caricamento…
        </div>
      </div>
    );

  return session ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
}
